import { fetcher } from '@commenda/utils';

// The computed schedule for a supported filing, fetched when the user advances past selection.
export interface FilingDueDate {
  firstDueDate: string;
  effectiveStartDate: string;
  effectiveEndDate: string;
}

export const getFilingDueDate = async (
  corporationId: number,
  complianceType: string
): Promise<FilingDueDate> => {
  const res = await fetcher(
    `compliance/filing-due-date?corporationId=${corporationId}&complianceType=${encodeURIComponent(
      complianceType
    )}`,
    { method: 'GET' }
  );
  if (!res.ok) throw new Error('Failed to fetch filing due date');
  return (await res.json()) as FilingDueDate;
};
